import { render, staticRenderFns } from "./DetailsGrid.vue?vue&type=template&id=7c2e55b0&"
import script from "./DetailsGrid.vue?vue&type=script&lang=js&"
export * from "./DetailsGrid.vue?vue&type=script&lang=js&"
import style0 from "./DetailsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports